/* eslint-disable jsx-a11y/anchor-is-valid */
import MainButton from "../../Component/Button/MainButton";
import BasicInput from "../../Component/Input/BasicInput";
import { dimmerStyles } from "../../Component/styles/mainStyles";
import { verifyLength } from "../../Service/Helper/Utils";
import BodyWrapper from "../../Component/Body/BodyWrapper";


function OtpPages({ state }) {
    const { otp, setOtp, handleLogin } = state
    const children = (<>
            <div
                style={dimmerStyles}
            ></div>

            {/* Content */}
            <div className="position-relative p-4 rounded-4">
            <h1 className="fw-bold display-4">2FA OTP</h1>
            <h4 className="display-4">Goodnet By Artamedia</h4>
            <p className="lead mb-4">
                Internet Cepat, Stabil, dan Tampa Batas
            </p>

            <BasicInput
                placeholder="Nomor Layanan (10 - 12) Digit"
                value={otp}
                onChange={(e) => {
                    if (!verifyLength(e.target.value, 12)) {
                        setOtp(e.target.value)
                    }
                }}
            />
            <br></br>
            <MainButton
                title={'Verified'}
                onClick={handleLogin}
            />
            </div>
    </>)

    return (
        <>
        <BodyWrapper
            children={children}
        />
        </>
    )
}

export default OtpPages;
